<div class="tracking-page-integrations-container" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white" [formGroupName]="'widgets'">
    <div class="card" [formGroupName]="'integrations'">
      <div class="header-container">
        <pdq-heading element="h5">Integrations</pdq-heading>
      </div>

      <ng-container>
        <pdq-divider></pdq-divider>
        <div class="card__content">
          <div class="integration" [formGroupName]="'uptick'">
            <div>
              <div class="header-container">
                <pdq-heading element="h6">Uptick</pdq-heading>
                <pdq-slide-toggle formControlName="enabled"></pdq-slide-toggle>
              </div>
              <span>Enable Uptick to add upsells on your tracking page</span>
            </div>
            <ng-container *ngIf="formGroup?.get('widgets')?.get('integrations').get('uptick').get('enabled')?.value">
              <pdq-input
                label="Uptick key"
                placeholder="Enter your Uptick key"
                formControlName="customerKey"></pdq-input>
            </ng-container>
          </div>

          <pdq-divider variant="dashed"></pdq-divider>

          <div class="integration" [formGroupName]="'disco'">
            <div>
              <div style="display: flex; flex-direction: column; gap: 8px">
                @if (formGroup?.get('settings')?.value | missingPrivacyMFA) {
                  <pdq-banner
                    variant="regular"
                    [closable]="false"
                    bannerTitle='For optimal Disco ad suggestions, enable at least 2 settings in the "Tracking Page Privacy Settings" section below.'></pdq-banner>
                }
                <div class="header-container">
                  <pdq-heading element="h6">Disco</pdq-heading>
                  <pdq-slide-toggle formControlName="enabled"></pdq-slide-toggle>
                </div>
                <span>Enable Disco ads to generate additional revenue</span>
              </div>
            </div>
            <ng-container *ngIf="formGroup?.get('widgets')?.get('integrations').get('disco').get('enabled')?.value">
              <pdq-input label="Disco key" placeholder="Enter your disco key" formControlName="customerKey"></pdq-input>
            </ng-container>
          </div>

          <pdq-divider variant="dashed"></pdq-divider>

          <div class="integration" [formGroupName]="'falcon'">
            <div>
              <div style="display: flex; flex-direction: column; gap: 8px">
                @if (formGroup?.get('settings')?.value | missingPrivacyMFA) {
                  <pdq-banner
                    variant="regular"
                    [closable]="false"
                    bannerTitle='For optimal Falcon ads suggestions, enable at least 2 settings in the "Tracking Page Privacy Settings" section below.'>
                  </pdq-banner>
                }
                <div class="header-container">
                  <pdq-heading element="h6">Falcon</pdq-heading>
                  <pdq-slide-toggle formControlName="enabled"></pdq-slide-toggle>
                </div>
                <span>Enable Falcon ads on your tracking page</span>
              </div>
            </div>
            <ng-container *ngIf="formGroup?.get('widgets')?.get('integrations').get('falcon').get('enabled')?.value">
              <pdq-input
                label="Falcon SDK Key"
                placeholder="Enter your Falcon SDK Key"
                formControlName="sdkKey"
                [invalid]="
                  formGroup?.get('widgets')?.get('integrations').get('falcon').get('sdkKey')?.hasError('required')
                "
                [invalidMsg]="'Required'">
              </pdq-input>
              <pdq-input
                label="Falcon Placement ID"
                placeholder="Enter your Falcon Placement ID"
                formControlName="customerKey"
                [invalid]="
                  formGroup?.get('widgets')?.get('integrations').get('falcon').get('customerKey')?.hasError('required')
                "
                [invalidMsg]="'Required'">
              </pdq-input>
              <pdq-radio-group label="Appearance" labelSize="small" formControlName="appearance">
                <pdq-radio-button
                  [value]="'modal'"
                  [text]="'Modal'"
                  [checked]="
                    formGroup?.get('widgets')?.get('integrations')?.get('falcon')?.get('appearance')?.value === 'modal'
                  ">
                </pdq-radio-button>
                <pdq-radio-button
                  [value]="'embedded'"
                  [text]="'Embedded'"
                  [checked]="
                    formGroup?.get('widgets')?.get('integrations')?.get('falcon')?.get('appearance')?.value ===
                    'embedded'
                  ">
                </pdq-radio-button>
              </pdq-radio-group>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </pdq-card>
</div>
